import * as React from 'react';
import { IconArrowLeft16, IconArrowRight16 } from '@cian/ui-kit';
import { ICustomSwiperNavigationRef } from '../../CustomSwiper';
import * as styles from './ArrowControls.css';

interface IArrowControlsProps {
  navRef: ICustomSwiperNavigationRef;
}

export function ArrowControls({ navRef }: IArrowControlsProps) {
  return (
    <div>
      <button
        className={`${styles['button']} ${styles['prev']}`}
        type="button"
        ref={navRef.prev}
        data-testid="promo-arrow-prev"
      >
        <IconArrowLeft16 color="gray_icons_100" />
      </button>
      <button
        className={`${styles['button']} ${styles['next']}`}
        type="button"
        ref={navRef.next}
        data-testid="promo-arrow-next"
      >
        <IconArrowRight16 color="gray_icons_100" />
      </button>
    </div>
  );
}
